import { ReactNode } from 'react';
import { TSelfEnrollmentStatus } from '@api/io/session.io';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';
import { useConfigContext } from '@fe-core';
import { ContinueButton } from '@components/EnrollmentActions/ContinueButton';
import { EnrollButton } from '@routes/selfreg/components/Enrollment/Actions/EnrollButton';

type TEnrollmentAction = {
  enrollmentAction: ReactNode;
};

export const enrollmentActionsMap: Record<
  TSelfEnrollmentStatus,
  ({
    sessionDetails,
  }: {
    sessionDetails: TSelfregSessionDetails;
  }) => TEnrollmentAction
> = {
  unenrolled: ({ sessionDetails }) => ({
    enrollmentAction: <EnrollButton sessionDetails={sessionDetails} />,
  }),
  active: ({ sessionDetails }) => ({
    enrollmentAction: sessionDetails.selfEnrollmentParticipationUrl && (
      <ContinueButton
        progress={sessionDetails.selfEnrollmentProgress}
        link={sessionDetails.selfEnrollmentParticipationUrl}
      />
    ),
  }),
  enrolled_confirmed: () => ({
    enrollmentAction: null,
  }),
  unknown: () => ({
    enrollmentAction: null,
  }),
};

type Props = {
  sessionDetails: TSelfregSessionDetails;
};

export const useSelfregEnrollmentActions = ({ sessionDetails }: Props) => {
  const { config } = useConfigContext();
  if (!config.loggedIn || !sessionDetails.selfEnrollmentStatus) {
    return null;
  }

  return enrollmentActionsMap[sessionDetails.selfEnrollmentStatus]({
    sessionDetails,
  });
};
